/*
 * Ajax filtering plugin
 */
;(function($) {
	function AjaxFiltering(options) {
		this.options = $.extend({
			container: '.js-ajax-container',
			items: '.filter-item',
			filterBlock: '.filter-block',
			filterForm: '.filter-form',
			searchForm: '.search-form',
			filterLists: '[data-category]',
			filterLinks: '[data-filter]',
			filterSelects: 'select',
			filterCheckboxes: ':checkbox',
			activeClass: 'active',
			loadingClass: 'loading',
			filteringClass: 'filtering',
			btnMore: '.btn-more',
			btnReset: '.btn-reset',
			ajaxPrefix: 'ajax=1',
			paging: '.nav-links',
			usePaging: true,
			infiniteScroll: false,
			animSpeed: 500,
			delay: 500
		}, options);

		this.init();
	}

	AjaxFiltering.prototype = {
		init: function() {
			if (this.options.holder) {
				this.findElements();
				this.attachEvents();
				this.makeCallback('onInit', this);
			}
		},
		findElements: function() {
			this.win = $(window);
			this.holder = $(this.options.holder);
			this.container = this.holder.find(this.options.container);
			this.filterBlock = this.holder.find(this.options.filterBlock);
			this.filterLists = this.holder.find(this.options.filterLists);
			this.searchForm = this.holder.find(this.options.searchForm);
			this.filterForm = this.holder.find(this.options.filterForm);
			this.filterCheckboxes = this.filterBlock.find(this.options.filterCheckboxes);
			this.filterSelects = this.filterBlock.find(this.options.filterSelects);
			this.btnReset = this.holder.find(this.options.btnReset);
			this.btnMore = this.holder.find(this.options.btnMore);
			this.paging = this.holder.find(this.options.paging);
			this.ajaxBusy = false;
			this.activeFilters = '';
		},
		attachEvents: function() {
			var self = this;

			this.btnMore.on('click', function(e) {
				e.preventDefault();

				if (!self.ajaxBusy) {
					self.ajaxRequest(self.btnMore.attr('href'));
				}
			});

			this.sendRequest = function() {
				if (!self.ajaxBusy) {
					self.ajaxRequest(null);
				}
			};

			this.onScrollHandler = function() {
				self.scrollHandler();
			};

			this.attachLinksEvents();

			if (this.options.infiniteScroll) {
				this.win.on('scroll', this.onScrollHandler);
			}
		},
		attachLinksEvents: function() {
			var self = this;

			this.filterLists.each(function() {
				var list = $(this);
				var filterLinks = list.find(self.options.filterLinks);
				var allItemsParents = filterLinks.parent();

				filterLinks.on('click', function(e) {
					e.preventDefault();
					if (self.ajaxBusy) return;

					var link = $(this);
					var parent = link.parent();

					if (list.data('multiselect')) {
						var state = false;

						if (parent.hasClass(self.options.activeClass)) {
							parent.removeClass(self.options.activeClass);
						} else {
							parent.addClass(self.options.activeClass);
							state = true;
						}

						if (link.data('filter').trim().toLowerCase() === 'all') {
							var allParents = list.children();

							if (state) {
								allParents.addClass(self.options.activeClass);
							} else {
								allParents.removeClass(self.options.activeClass);
							}
						} else {
							filterLinks.each(function() {
								var item = $(this);

								if (item.data('filter').trim().toLowerCase() === 'all') {
									if (!state) {
										item.parent().removeClass(self.options.activeClass);
									}

									if (list.find('.' + self.options.activeClass).length === filterLinks.length - 1) {
										item.parent().addClass(self.options.activeClass);
									}
								}
							});
						}
					} else {
						if (parent.hasClass(self.options.activeClass)) {
							parent.removeClass(self.options.activeClass);
						} else {
							allItemsParents.removeClass(self.options.activeClass);
							parent.addClass(self.options.activeClass);
						}
					}

					self.updateFilters();
					self.sendRequest();
				});
			});

			this.filterForm.on('submit', function(e) {
				e.preventDefault();
				self.sendRequest();
			});

			this.searchForm.on('submit', function(e) {
				e.preventDefault();
				self.sendRequest();
			});

			this.filterCheckboxes.add(this.filterSelects).on('change', this.sendRequest);

			this.paging.on('click', 'a', function(e) {
				e.preventDefault();
				var link = $(this);

				if (!self.ajaxBusy) {
					self.ajaxRequest(null, link.data('page') || '1');
				}
			});

			this.btnReset.on('click', function() {
				if (self.filterForm.length) {
					self.filterForm[0].reset();
				}

				if (self.searchForm.length) {
					self.searchForm[0].reset();
				}

				self.filterSelects.each(function() {
					var select = jQuery(this);
					var options = select.find('option');

					options.removeAttr('selected');
					options.eq(0).attr('selected', true);

					// jcf.refresh(select);
				});

				setTimeout(function() {
					self.sendRequest();
				}, 500);
			});
		},
		scrollHandler: function() {
			if (this.win.scrollTop() + ((this.win.height() / 5) * 4) >= this.container.offset().top + this.container.outerHeight()) {
				if (!this.ajaxBusy && this.btnMore.length) {
					this.ajaxRequest(this.btnMore.attr('href'));
				}
			}
		},
		updateFilters: function() {
			var self = this;

			this.activeFilters = '';

			this.filterLists.each(function() {
				var currList = $(this);
				var activeItems = currList.find('.' + self.options.activeClass + ' > ' + self.options.filterLinks);
				var filters = [];

				activeItems.each(function() {
					filters.push($(this).data('filter').trim());
				});

				if (filters.length) {
					self.activeFilters += '&' + currList.data('category') + '=' + filters.join(',');
				}
			});
		},
		ajaxRequest: function(src, pageNum) {
			var self = this;
			var filterFormSerialize = this.filterForm.length ? '&' + this.filterForm.serialize() : '';
			var searchFormSerialize = this.searchForm.length ? '&' + this.searchForm.serialize() : '';
			var page = '';

			if (this.options.usePaging) {
				page = pageNum ? '&paged=' + pageNum : '&paged=1';
			}

			this.ajaxBusy = true;
			this.btnMore.hide();
			this.holder.addClass(this.options.loadingClass);
			this.makeCallback('sendRequest', this);

			if (!src) {
				this.holder.addClass(this.options.filteringClass);
			}

			$.ajax({
				url: src ? src : this.holder.data('action'),
				type: this.holder.data('method') || 'POST',
				data: this.options.ajaxPrefix + this.activeFilters + filterFormSerialize + searchFormSerialize + page,
				dataType: 'text',
				success: function(data) {
					var ifPageLoad = pageNum ? true : false;

					self.onSuccess(data, src, ifPageLoad);
				}
			});
		},
		onSuccess: function(data, src, ifPageLoad) {
			var self = this;
			var loadedBlock = $('<div/>').html(data);
			var items = loadedBlock.find(this.options.items);
			var btnMore = loadedBlock.find(this.options.btnMore);
			var paging = loadedBlock.find(this.options.paging);

			this.makeCallback('onLoad', items);

			setTimeout(function() {
				if (!src) {
					self.container.empty();

					self.makeCallback('onFilter', self, loadedBlock);
				}

				self.holder.removeClass(self.options.filteringClass);
				items.hide().appendTo(self.container);

				if (btnMore.length) {
					self.btnMore.attr('href', btnMore.attr('href'));

					if (self.options.infiniteScroll) {
						self.win.on('scroll', self.onScrollHandler);
					} else {
						self.btnMore.show();
					}
				} else {
					if (self.options.infiniteScroll) {
						self.win.off('scroll', self.onScrollHandler);
					}
				}

				if (paging.length) {
					self.paging.html(paging.html());
				}

				self.makeCallback('onSuccess', items);
				self.holder.removeClass(self.options.loadingClass);
				items.fadeIn(self.options.animSpeed);

				if (ifPageLoad) {
					$('html, body').animate({
						scrollTop: self.holder.offset().top
					}, 650);
				}

				self.ajaxBusy = false;
			}, this.options.delay);
		},
		makeCallback: function(name) {
			if (typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);

				args.shift();
				this.options[name].apply(this, args);
			}
		}
	};

	$.fn.ajaxFiltering = function(opt) {
		return this.each(function() {
			$(this).data('AjaxFiltering', new AjaxFiltering($.extend(opt, {
				holder: this
			})));
		});
	};
}(jQuery));